module.exports = __webpack_public_path__ + "at.no2.f8c22508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/at.no2.jpg
// module id = lyGy
// module chunks = 0